import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { RegularGrid } from "src/types";

export function useRegularGridSchema(data: RegularGrid) {
  const { t } = useTranslation();

  return Yup.object().shape({
    xcount: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.numberOfPointsInXDirection"),
        })
      )
      .min(
        data.xcount.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.numberOfPointsInXDirection"),
          value: data.xcount.minMaxDefault.min,
        })
      )
      .max(
        data.xcount.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.numberOfPointsInXDirection"),
          value: data.xcount.minMaxDefault.max,
        })
      ),
    ycount: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.numberOfPointsInYDirection"),
        })
      )
      .min(
        data.ycount.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.numberOfPointsInYDirection"),
          value: data.ycount.minMaxDefault.min,
        })
      )
      .max(
        data.ycount.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.numberOfPointsInYDirection"),
          value: data.ycount.minMaxDefault.max,
        })
      ),
    distance: Yup.number()
      .required(
        t("label.isRequiredValidation", {
          field: t("label.distanceBetweenPoints"),
        })
      )
      .min(
        data.distance.minMaxDefault.min || -Infinity,
        t("label.minRequirementValidation", {
          field: t("label.distanceBetweenPoints"),
          value: data.distance.minMaxDefault.min,
        })
      )
      .max(
        data.distance.minMaxDefault.max || Infinity,
        t("label.maxRequirementValidation", {
          field: t("label.distanceBetweenPoints"),
          value: data.distance.minMaxDefault.max,
        })
      ),
  });
}
